// Category order configuration for tools and skills
// This file defines the order in which categories should appear in the UI
export const CATEGORY_ORDER = [
  'All',
  'Cloud',
  'Code',
  'Compliance',
  'Messaging',
  'Ticketing',
  'Browser',
] as const;

export type CategoryType = (typeof CATEGORY_ORDER)[number];

// Helper function to get the sort order for a category
export const getCategorySortOrder = (category: string): number => {
  const index = CATEGORY_ORDER.indexOf(category as CategoryType);
  return index === -1 ? CATEGORY_ORDER.length : index; // Categories not in the list go to the end
};

// Helper function to sort categories according to the order
export const sortCategories = (categories: string[]): string[] => {
  return [...categories].sort((a, b) => {
    const orderA = getCategorySortOrder(a);
    const orderB = getCategorySortOrder(b);
    return orderA - orderB;
  });
};
